module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/plan1-3-2eb1d3b6811135c1f4435f15fd1c4f45.webp";